export default __webpack_public_path__ + "static/media/flag-en.d029b444.svg";